import React, { Component } from "react";

import { withRequest } from "../../../utils/request";
import Pagination from "../../general/Pagination";
import Modal from "../../general/Modal";
import Create from "./Create";
import Edit from "./Edit";
import Loader from "../../general/Loader";
import { Link } from "react-router-dom";
import { getLink } from "../../../utils/helpers";

class Almacenes extends Component {
    state = {
        almacenes: {},
        almacen: {},
        links: null,
        showCreate: false,
        showEdit: false,
        loading: true,
    };
    componentDidMount() {
        this.getAlmacenes();
    }
    getAlmacenes = async (url = null) => {
        url = url ? url : "almacenes";
        const almacenes = await this.props.request(url);

        if (almacenes.data) {
            this.setState({
                almacenes: almacenes.data,
                loading: false,
            });
        }
    };
    toggleCreateModal = () => {
        this.setState({
            showCreate: !this.state.showCreate,
            almacen: {},
        });
    };
    toggleEditModal = (almacen) => {
        this.setState({
            showEdit: !this.state.showEdit,
            almacen: almacen,
        });
    };
    render() {
        const { almacenes, loading } = this.state;
        return (
            <div>
                <div className='page-header'>
                    <Link to={getLink('/configuracion/')}>&laquo; Volver a configuración</Link>
                    <h1 className='page-title row'>
                        <span className='col'>Almacenes</span>
                        <button
                            className='au-btn au-btn-icon au-btn--green au-btn--small'
                            onClick={this.toggleCreateModal}>
                            <i className='zmdi zmdi-plus' />
                            Añadir Almacen
                        </button>
                    </h1>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div>
                            {loading && <Loader />}
                            {!almacenes.length ? (
                                <div>
                                    {!loading && (
                                        <div>
                                            Todavía no hay almacenes creados.
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className='table-data'>
                                    <table className='table table-data2'>
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Items</th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {almacenes.map((almacen) => (
                                                <tr
                                                    className='tr-shadow'
                                                    key={almacen.id}>
                                                    <td>
                                                        {almacen.nombre}{" "}
                                                        {almacen.principal && (
                                                            <span className='badge badge-success'>
                                                                PRINCIPAL
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td>{almacen.items}</td>
                                                    <td>
                                                        <div className='table-data-feature'>
                                                            <button
                                                                className='item'
                                                                data-toggle='tooltip'
                                                                data-placement='top'
                                                                title=''
                                                                data-original-title='Edit'
                                                                onClick={() => {
                                                                    this.toggleEditModal(
                                                                        almacen
                                                                    );
                                                                }}>
                                                                <i className='zmdi zmdi-edit' />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {this.state.links && (
                                        <Pagination
                                            links={this.state.links}
                                            meta={this.state.meta}
                                            getData={this.getAlmacenes}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <Modal
                    show={this.state.showCreate}
                    blank={true}
                    toggle={this.toggleCreateModal}>
                    <Create
                        toggle={this.toggleCreateModal}
                        almacen={this.state.almacen}
                        getAlmacenes={this.getAlmacenes}
                    />
                </Modal>
                <Modal
                    show={this.state.showEdit}
                    blank={true}
                    toggle={() => this.toggleEditModal({})}>
                    <Edit
                        toggle={() => this.toggleEditModal({})}
                        almacen={this.state.almacen}
                        getAlmacenes={this.getAlmacenes}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRequest(Almacenes);
